import { createReducer, on } from '@ngrx/store';
import { IDeliveryService } from 'src/app/shared/interfaces/deliveryService/ideliveryService';
import {
  loadDeliveryService,
  loadDeliveryServiceSuccess,
  saveDeliveryServiceSuccess,
} from './delivery-service.actions';

export interface IDeliveryServiceState {
  lista: IDeliveryService[];
  isLoading: boolean
}

const initialState: IDeliveryServiceState = {
  lista: [],
  isLoading: false
};

export const deliveryServiceReducer = createReducer(
  initialState,
  on(loadDeliveryService, (state) => ({
    ...state,
    isLoading: true
  }))
  ,
  on(loadDeliveryServiceSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false
  })),

  on(saveDeliveryServiceSuccess, (state, { deliveryService }) => ({
    ...state,
    lista: [...state.lista, deliveryService],
  }))
);
